import { provideWidgetClass } from 'scrivito'

export const DXPMyContactsWidget = provideWidgetClass('DXPMyContactsWidget', {
  attributes: {},
})
